<template>
  <div class="panel panel-default panel-fill">
    <div class="panel-heading">
      <h3 class="panel-title">
        {{ trans("menu.settings") }}
      </h3>
    </div>
    <div class="panel-body col-md-12">
      <p v-if="!hasVisibleFeatures" class="tw-mb-0">
        {{ trans("feature.emptyListMessage") }}
      </p>
      <div v-else class="row col-md-12 my-3 tw-gap-y-8">
        <div
          v-for="feature in simpleFeatures"
          :key="feature.id"
          :data-test="`admin-feature-${feature.name}`"
          class="col-md-3 col-sm-4"
        >
          <DerToggleWithLabel
            v-model="features[feature.id].active"
            :label="formatFeatureLabel(feature.name)"
            :disabled="center.id && !center.active"
          />
        </div>
      </div>
    </div>

    <div v-if="hasVisibleFeatures" class="row">
      <div
        v-for="feature in featuresWithOwnComponents"
        :key="feature.id"
        class="col-md-6 mb-4"
      >
        <component
          :is="featureComponents[feature.name]"
          :key="feature.id"
          :center="center"
          :region="region"
          :feature-id="feature.id"
          :features="features"
          :saved="saved"
          :label="formatFeatureLabel(feature.name)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FeatureConfigPanel from "./FeatureConfigPanel.vue";
import KibiConfigPanel from "./KibiConfigPanel.vue";
import PicsaraConfigPanel from "./PicsaraConfigPanel.vue";
import ImageFooter from "./ImageFooter.vue";
import Ucr from "./Ucr.vue";
import Webdoc from "./Webdoc.vue";
import DefaultReserveNumberPrefix from "./DefaultReserveNumberPrefix.vue";
import ExcludedMobileAuthenticationMethods from "./ExcludedMobileAuthenticationMethods.vue";
import ExcludedWebAuthenticationMethods from "./ExcludedWebAuthenticationMethods.vue";
import HideCasesFromWeb from "./HideCasesFromWeb.vue";
import PostSyncRemoval from "./PostSyncRemoval.vue";
import RequestStudyConsent from "./RequestStudyConsent.vue";
import DerToggleWithLabel from "../../design-system/DerToggleWithLabel.vue";

export default {
  components: {
    DerToggleWithLabel,
    Ucr,
    Webdoc,
    DefaultReserveNumberPrefix,
    ExcludedMobileAuthenticationMethods,
    ExcludedWebAuthenticationMethods,
    FeatureConfigPanel,
    RequestStudyConsent,
    ImageFooter,
  },
  props: {
    features: {
      type: Object,
      default: () => ({}),
    },
    center: {
      type: Object,
      default: () => ({}),
    },
    region: {
      type: Object,
      default: () => ({}),
    },
    manageableOnly: {
      type: Boolean,
      default: false,
    },
    saved: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      featureComponents: {
        Webdoc: Webdoc,
        Ucr,
        DefaultReserveNumberPrefix,
        ExcludedWebAuthenticationMethods,
        ExcludedMobileAuthenticationMethods,
        Kibi: KibiConfigPanel,
        Medialab: FeatureConfigPanel,
        Picsara: PicsaraConfigPanel,
        HideCasesFromWeb,
        PostSyncRemoval,
        RequestStudyConsent,
        ImageFooter,
      },
    };
  },
  computed: {
    visibleFeatures() {
      if (!this.manageableOnly) return this.features;
      return Object.fromEntries(
        Object.entries(this.features).filter(
          ([, f]) => f.region_admin_manageable,
        ),
      );
    },
    simpleFeatures() {
      // Make sure the features are sorted by their label
      return Object.values(this.visibleFeatures)
        .filter((feature) => !this.featureComponents[feature.name])
        .sort((a, b) => {
          const labelA = this.formatFeatureLabel(a.name).toLowerCase();
          const labelB = this.formatFeatureLabel(b.name).toLowerCase();
          return labelA.localeCompare(labelB);
        });
    },
    featuresWithOwnComponents() {
      return Object.values(this.visibleFeatures).filter(
        (feature) => this.featureComponents[feature.name],
      );
    },
    hasVisibleFeatures() {
      return (
        this.simpleFeatures.length + this.featuresWithOwnComponents.length > 0
      );
    },
  },
  methods: {
    formatFeatureLabel(name) {
      const key = "feature." + name.charAt(0).toLowerCase() + name.slice(1);
      return this.trans(key);
    },
  },
};
</script>
